import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Countries extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'Countries'
  // Define default properties here
  static instanceDefaults () {
    return {
      name: '',
      code: '',
      native: '',
      isEnabled: false,
    }
  }
}
const servicePath = 'countries'
const servicePlugin = makeServicePlugin({
  Model: Countries,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
